import { ref } from 'vue'
import { useApi } from '@/api/useApi'
import API from '@/api/apiUrls'
import { defineStore } from 'pinia'
import { type UserType } from '@/stores/type/authDjango.type'
import { useSearchUserBaseStore } from '@haskoning/vue-basestore'

const api = useApi<UserType>()
const userIndex = API.CORE.USERS.INDEX
const currentUser = API.CORE.USERS.CURRENT_USER

export const useAuthenticationStore = defineStore('auth', () => {
	const user = ref<UserType | null>(null)
	const searchUserBaseStore = useSearchUserBaseStore<UserType>(api, userIndex)

	const authenticate = async (payload: { email: string; password: string }) => {
		await api.apiService.authenticationHandler.authenticate(payload.email, payload.password)
		const userResponse = await api.service(currentUser).get()
		user.value = userResponse
		return { user: userResponse }
	}

	const reAuthenticate = async () => {
		await api.apiService.authenticationHandler.setAccessTokenInHeaderFromStore()
		try {
			const userResponse = await api.service(currentUser).get()
			if (userResponse) {
				user.value = userResponse
			}
			return { user: user.value }
		} catch (e) {
			user.value = null
			return { user: null }
		}
	}

	const logout = () => {
		localStorage.removeItem('access')
		localStorage.removeItem('refresh')
		user.value = null
	}

	return {
		...searchUserBaseStore,
		user,
		authenticate,
		reAuthenticate,
		logout
	}
})
